module.exports = __webpack_public_path__ + "static/media/default-app-icon.32c6c795.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/default-app-icon.svg
// module id = ceBF
// module chunks = 89